import Wedding from './Wedding/Wedding';

export default Wedding;